import React from "react";
import {
  makeStyles,
  Typography,
  Card,
  CardContent,
  Link,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Box,
} from "@material-ui/core";
import { Favorite, ExpandMore } from "@material-ui/icons";
import { COLORS } from "../../types";
import ac from "../../img/ac.svg";
import { useMediaQuery } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

const useStyles = makeStyles({
  apexRed: {
    color: COLORS.RED,
  },
  panelHeader: {
    fontWeight: "bold",
  },
  ac: {
    height: "1.25em",
    verticalAlign: "middle",
  },
});

const panelHeaderDate = {
  display: "inline-block",
  marginLeft: "0.3rem",
  opacity: 0.5,
  fontWeight: "normal",
  fontSize: "0.75rem",
};

const ulStyle = {
  marginTop: 0,
  display: "block",
};

const codeStyle = {
  backgroundColor: "#ffffff11",
  padding: "0px 2px",
  fontSize: "0.8rem",
};

export default () => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(0);
  const [changelogPanel, setChangelogPanel] = React.useState(15);
  // SEASON+

  const mqL = useMediaQuery("(min-width: 1021px)");
  const mqM = useMediaQuery("(min-width: 776px) and (max-width: 1020px)");
  const mqS = useMediaQuery("(min-width: 371px) and (max-width: 775px)");
  const mqXS = useMediaQuery("(max-width: 370px)");

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);

    window.gtag("event", "click", {
      event_category: "FAQ Panels",
      event_action: `FAQ Panel ${panel}: ${isExpanded ? "Open" : "Close"}`,
    });
  };

  const handleChangelog = (panel) => (event, isExpanded) => {
    setChangelogPanel(isExpanded ? panel : false);

    window.gtag("event", "click", {
      event_category: "Changelog Panels",
      event_action: `Changelog Panel ${panel}: ${
        isExpanded ? "Open" : "Close"
      }`,
    });
  };

  const faqEntries = [
    {
      q: `Why can't I sign into my Apex Legends account to automatically see my number of packs opened?`,
      a: `The simple answer is unlike other games, downloading stats is not availble because they are not offered. If Respawn / EA ever decide to offer a stats API, I'll be ready to build in the functionality for the most accurate reporting possible.`,
    },
    {
      q: `How does the APEX PACKS HELD AT LAST HEIRLOOM field work in the Heirlooms feature?`,
      a: `This field acts as your "new zero." When going after your first Heirloom, your progress is tracked from packs 0 > 500.  If you last received Heirloom shards when you were holding 100 Apex Packs, your next journey is from packs 100 > 600, and the percentages are now updated to track towards your new end goal.`,
    },
    {
      q: `How are the account packs calculated?`,
      a: (
        <>
          <span>
            <Typography variant="body2" paragraph={true}>
              Official information about the number of packs received through
              account progression can be found in{" "}
              <Link
                href="https://www.ea.com/games/apex-legends/news/progression-changes"
                target="_blank"
                rel="noopener noreferrer"
              >
                this blog post from Respawn
              </Link>{" "}
              detailing the Player Level Progression Changes.
            </Typography>

            <Typography variant="body2" paragraph={false}>
              The math as it's implemented here looks like this:
            </Typography>
            <ul style={ulStyle}>
              <li>
                <strong>Levels 2 - 20:</strong> <code style={codeStyle}>1</code>{" "}
                pack / level
              </li>
              <li>
                <strong>Levels 21 - 300:</strong>{" "}
                <code style={codeStyle}>0.5</code> packs / level
              </li>
              <li>
                <strong>Levels 301 - 500:</strong>{" "}
                <code style={codeStyle}>0.2</code> packs / level
              </li>
            </ul>
          </span>
        </>
      ),
    },
    {
      q: `How can I find out how many Apex Packs I have purchased?`,
      a: (
        <>
          <span>
            <Typography variant="body2" paragraph={true}>
              The short answer is - there is no reliable way to find this
              number.
            </Typography>

            <Typography variant="body2" paragraph={true}>
              The way to get the best estimate is to review your purchase
              history of <img src={ac} className={classes.ac} alt="AC" />.
              Access your gaming store profile on your platform, and look for a
              listing of transactions. From here you can take a best guess (or
              better yet, if you remember specifically) how many Apex Packs were
              purchased using <img src={ac} className={classes.ac} alt="AC" />.
            </Typography>

            <Typography variant="body2" paragraph={true}>
              Another way to think about this is to sum the total amount of{" "}
              <img src={ac} className={classes.ac} alt="AC" /> purchased,
              subtract any currency used for Legend and weapon skins, subtract
              away remaining currency on your account right now, and the
              remaining amount <em>may</em> have gone to Apex Pack direct
              purchases<sup>*</sup>.
            </Typography>

            <Typography variant="caption" paragraph={true}>
              <sup>*</sup>{" "}
              <small style={{ verticalAlign: "middle" }}>
                or not, who knows
              </small>
            </Typography>
          </span>
        </>
      ),
    },
    {
      q: `My total reported has changed since the last update, what gives?`,
      a: (
        <>
          <span>
            <Typography variant="body2" paragraph={true}>
              In the initial release packs were evenly distributed. This meant
              that 5 packs over 100 levels yielded 1 additional pack per every
              20 levels. The problem with that strategy is it didn't reflect
              real life. At all.
            </Typography>

            <Typography variant="body2" paragraph={true}>
              In the most recent update I've enhanced the pack distributions to
              reflect what really happened in the Battle Passes, thanks to the
              record keeping by the fine folks over at{" "}
              <Link
                href="https://apexlegends.gamepedia.com/Apex_Legends_Wiki"
                target="_blank"
                rel="noopener noreferrer"
              >
                the Gamepedia Apex Legends Wiki
              </Link>
              . Their resources were invaluable in researching historical
              records of previous Battle Pass rewards. Using their records of
              awards by level, I was able to modify my code to reflect rewards
              that you actually earned (instead of just guessing).
            </Typography>

            <Typography variant="body2" paragraph={true}>
              The side effect of this change is that your tallys might have
              changed - even when running the exact same numbers. The good news
              is that most players{"'"} totals will have gone <em>up</em>{" "}
              slightly, so there's that.
            </Typography>
          </span>
        </>
      ),
    },
    {
      q: `I recall receiving 2 bonus packs from the Iron Crown event, why aren't they aren't reflected?`,
      a: (
        <Typography variant="body2">
          I have seen reports of the 2 missing Iron Crown bonus packs, however I
          have heard the counterargument that these packs do not count towards
          the overall heirloom goal since they were "purchased" with event
          crowns. For now they can be added using the Bugs + Misc field if you
          acquired one or both.
        </Typography>
      ),
    },
    {
      q: `I set my location to Belgium so that I would receive only crafting materials, are my figures still accurate?`,
      a: (
        <>
          <span>
            <Typography variant="body2" paragraph={true}>
              The short answer is <strong>yes</strong>.
            </Typography>

            <Typography variant="body2">
              The longer answer is according to{" "}
              <Link
                href="https://www.eurogamer.net/articles/2019-03-20-apex-legends-players-are-ditching-loot-boxes-for-crafting-materials-by-changing-their-region-to-belgium"
                target="_blank"
                rel="noopener noreferrer"
              >
                reports
              </Link>
              , players who choose to enforce the Belgium anti-gambling rules
              will still be eligible to receive the regular{" "}
              <code style={codeStyle}>5</code> free packs as usual, and they can
              earn the usual <code style={codeStyle}>7</code> premium packs with
              the purchase of the premium Battle Pass, resulting in the
              potential for the same amount of packs opened even though the
              reward pool has changed for the premium packs.
            </Typography>
          </span>
        </>
      ),
    },
  ];

  return (
    <div className="width-constrained">
      <Typography variant="h6">Frequently Asked Questions</Typography>
      <Box style={{ marginBottom: "2rem" }}>
        {faqEntries.map((thisEntry, i) => (
          <ExpansionPanel
            expanded={expanded === i}
            onChange={handleChange(i)}
            key={i}
          >
            <ExpansionPanelSummary expandIcon={<ExpandMore />}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                {thisEntry.q}
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>{thisEntry.a}</ExpansionPanelDetails>
          </ExpansionPanel>
        ))}
      </Box>

      {/* Outlands Companion Plug */}
      <div
        style={{
          marginTop: 36,
          marginBottom: 36,
        }}
      >
        <Alert
          severity="info"
          style={{
            width: mqXS ? 240 : mqS ? "auto" : mqM ? 700 : mqL ? 938 : "auto",
            margin: "0 auto",
            border: "1px solid #E24C3C",
          }}
          icon={
            <img
              src={require("../../img/outlands-companion-icon.png")}
              style={{ width: 44, height: 44 }}
              alt="Outlands Companion Icon"
            />
          }
        >
          <span style={{ fontSize: 14, color: "#FFF" }}>
            <strong style={{ fontSize: 18 }}>
              Check Out Outlands Companion for iOS and Android!&nbsp;
              <span role="img" aria-label="Party Emoji">
                🎉
              </span>
            </strong>
            <br />
            <span style={{ opacity: 0.8 }}>
              Heirloom calculator optimized for your phone and
              more&nbsp;features!
            </span>
            <br />
            <a
              href="https://apps.apple.com/app/outlands-companion/id1550486367"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#FFFFFF",
                textAlign: "left",
                textDecoration: "none",
                whiteSpace: "nowrap",
              }}
            >
              <strong style={{ textDecoration: "underline" }}>
                Download for iOS
              </strong>
            </a>{" "}
            &bull;{" "}
            <a
              href="https://play.google.com/store/apps/details?id=com.zarandona.mike.outlandscompanion"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#FFFFFF",
                textAlign: "left",
                textDecoration: "none",
                whiteSpace: "nowrap",
              }}
            >
              <strong style={{ textDecoration: "underline" }}>
                Download for Android
              </strong>
            </a>
          </span>
        </Alert>
      </div>

      <Typography variant="h6">Thanks</Typography>
      <Card style={{ marginBottom: "2rem" }}>
        <CardContent>
          <Typography paragraph={true}>
            Thanks to <strong className={classes.apexRed}>Respawn</strong> for
            making such an incredible game and community. Everything that looks
            like Apex Legends belongs to Respawn and EA, please don't sue me.{" "}
            <Favorite
              style={{
                color: COLORS.RED,
                fontSize: "1em",
                verticalAlign: "sub",
              }}
            />
          </Typography>

          {/*
          <Typography style={{ display: "block" }}>
            If you'd like to support me and other nerdy projects like this, you
            can buy me a coffee on Patreon:
          </Typography>

          <Button
            href="https://www.patreon.com/mikezarandona"
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            color="primary"
            style={{ marginBottom: 24, marginTop: 6 }}
          >
            <Favorite style={{ fontSize: "1em" }} /> &nbsp;Support Me on Patreon
          </Button>
          */}

          <Typography variant="caption" paragraph={true}>
            Special thanks to{" "}
            <strong className={classes.apexRed}>Dr Face (XBL)</strong> (who had
            this idea) and{" "}
            <strong className={classes.apexRed}>R L ST1NE (XBL)</strong>.
            <br />
            <em style={{ color: "#aaa" }}>
              "Team mates heyah, level four bruddahs!"
            </em>
          </Typography>
        </CardContent>
      </Card>

      <Typography variant="h6">Changelog</Typography>
      <Box>
        {/* SEASON+ */}
        <ExpansionPanel
          expanded={changelogPanel === 15}
          onChange={handleChangelog(15)}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMore />}>
            <Typography
              variant="body1"
              classes={{ body1: classes.panelHeader }}
            >
              v1.2.2 <code style={panelHeaderDate}>2022.05.02</code>
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails style={{ flexDirection: "column" }}>
            <strong>Added</strong>
            <ul style={ulStyle}>
              <li>Season 13: Saviors support</li>
              <li>3rd Anniversary Event</li>
              <li>Heirlooms: Crypto's Biwon Blade added</li>
              <li>Heirlooms: Added Prestige Skins support</li>
            </ul>
            <strong>Fixed</strong>
            <ul style={ulStyle}>
              <li>
                Treasure packs countdown tracks most current season as expected
              </li>
              <li>Season 12 battle pass levels updated to reflect real life</li>
            </ul>
            <strong>Changed</strong>
            <ul style={ulStyle}>
              <li>
                Complete overhaul under the hood for reliability, performance,
                and support of future plans
              </li>
              <li>
                Swapped out a few libraries for faster bundling and reduced
                bundle size (also my sanity)
              </li>
              <li>
                Some developer quality of life updates to ensure best-in-class
                long term support
              </li>
              <li>
                Moved annoying Outlands Companion plug to the More Info section
              </li>
            </ul>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel
          expanded={changelogPanel === 14}
          onChange={handleChangelog(14)}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMore />}>
            <Typography
              variant="body1"
              classes={{ body1: classes.panelHeader }}
            >
              v1.2.1 <code style={panelHeaderDate}>2022.02.08</code>
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails style={{ flexDirection: "column" }}>
            <ul style={ulStyle}>
              <li>Added support for Season 12: Defiance</li>
              <li>
                Updated the third heirloom stat to "
                <em>packs needed until next back luck protection"</em> versus a
                flat "<em>500 packs</em>"
              </li>
            </ul>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel
          expanded={changelogPanel === 13}
          onChange={handleChangelog(13)}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMore />}>
            <Typography
              variant="body1"
              classes={{ body1: classes.panelHeader }}
            >
              v1.2.0 <code style={panelHeaderDate}>2022.01.22</code>
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails style={{ flexDirection: "column" }}>
            <ul style={ulStyle}>
              <li>Added Heirlooms feature</li>
              <li>Fixed issue with treasure packs countdown tracker</li>
              <li>Changed site to fixed width for more consistent layout</li>
            </ul>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel
          expanded={changelogPanel === 12}
          onChange={handleChangelog(12)}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMore />}>
            <Typography
              variant="body1"
              classes={{ body1: classes.panelHeader }}
            >
              v1.1.11 <code style={panelHeaderDate}>2021.11.03</code>
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails style={{ flexDirection: "column" }}>
            <ul style={ulStyle}>
              <li>Added support for Season 11: Escape</li>
              <li>Added support for S10 LTM: Monsters Within</li>
            </ul>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel
          expanded={changelogPanel === 11}
          onChange={handleChangelog(11)}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMore />}>
            <Typography
              variant="body1"
              classes={{ body1: classes.panelHeader }}
            >
              v1.1.10 <code style={panelHeaderDate}>2021.09.08</code>
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails style={{ flexDirection: "column" }}>
            <ul style={ulStyle}>
              <li>Added support for S9 LTM: Thrillseekers</li>
              <li>Added support for Arenas Flash Events</li>
              <li>
                Rearranged Purchased Packs with Twitch Prime for better flow
              </li>
            </ul>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel
          expanded={changelogPanel === 10}
          onChange={handleChangelog(10)}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMore />}>
            <Typography
              variant="body1"
              classes={{ body1: classes.panelHeader }}
            >
              v1.1.9 <code style={panelHeaderDate}>2021.08.06</code>
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails style={{ flexDirection: "column" }}>
            <ul style={ulStyle}>
              <li>Added support for Season 10: Emergence</li>
            </ul>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel
          expanded={changelogPanel === 9}
          onChange={handleChangelog(9)}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMore />}>
            <Typography
              variant="body1"
              classes={{ body1: classes.panelHeader }}
            >
              v1.1.8 <code style={panelHeaderDate}>2021.06.04</code>
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails style={{ flexDirection: "column" }}>
            <ul style={ulStyle}>
              <li>Small bug fix</li>
            </ul>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel
          expanded={changelogPanel === 8}
          onChange={handleChangelog(8)}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMore />}>
            <Typography
              variant="body1"
              classes={{ body1: classes.panelHeader }}
            >
              v1.1.7 <code style={panelHeaderDate}>2021.05.15</code>
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails style={{ flexDirection: "column" }}>
            <ul style={ulStyle}>
              <li>Added support for Season 9: Legacy</li>
            </ul>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel
          expanded={changelogPanel === 7}
          onChange={handleChangelog(7)}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMore />}>
            <Typography
              variant="body1"
              classes={{ body1: classes.panelHeader }}
            >
              v1.1.6 <code style={panelHeaderDate}>2021.02.23</code>
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails style={{ flexDirection: "column" }}>
            <ul style={ulStyle}>
              <li>Fixed Anniversary LTM to cap at 10 Apex Packs (not 12)</li>
              <li>
                Fixed treasure pack counts to accurately reflect Apex Packs from
                quests
              </li>
            </ul>

            <div style={{ marginTop: 12, fontSize: "0.8em" }}>
              Special thanks to u/King-Kamina who took the time to point out
              issues and follow through with documentation.{" "}
              <span role="img" aria-label="crown emoji">
                👑
              </span>
            </div>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel
          expanded={changelogPanel === 6}
          onChange={handleChangelog(6)}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMore />}>
            <Typography
              variant="body1"
              classes={{ body1: classes.panelHeader }}
            >
              v1.1.5 <code style={panelHeaderDate}>2021.02.19</code>
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <ul style={ulStyle}>
              <li>Added support for Season 8: Mayhem</li>
              <li>
                Added support for 2<sup>nd</sup> Anniversary Event
              </li>
              <li>Fixed Season 7 Treasure Packs total count</li>
            </ul>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel
          expanded={changelogPanel === 5}
          onChange={handleChangelog(5)}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMore />}>
            <Typography
              variant="body1"
              classes={{ body1: classes.panelHeader }}
            >
              v1.1.4 <code style={panelHeaderDate}>2020.11.18</code>
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <ul style={ulStyle}>
              <li>Added support for Season 7: Ascension</li>
              <li>Added support for future enhancements and projects</li>
            </ul>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel
          expanded={changelogPanel === 4}
          onChange={handleChangelog(4)}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMore />}>
            <Typography
              variant="body1"
              classes={{ body1: classes.panelHeader }}
            >
              v1.1.3 <code style={panelHeaderDate}>2020.08.18</code>
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <ul style={ulStyle}>
              <li>Added support for Season 6: Boosted</li>
            </ul>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel
          expanded={changelogPanel === 3}
          onChange={handleChangelog(3)}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMore />}>
            <Typography
              variant="body1"
              classes={{ body1: classes.panelHeader }}
            >
              v1.1.2 <code style={panelHeaderDate}>2020.06.07</code>
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <ul style={ulStyle}>
              <li>Added Treasure Packs countdown feature</li>
              <li>
                Updated Seasonal Quests to accept Treasure Packs versus Apex
                Packs
              </li>
              <li>
                Added warning message to users who had used the calculator
                before the change to Treasure Packs
              </li>
              <li>
                Added more information to purchased packs with supporting FAQ
                entry
              </li>
            </ul>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel
          expanded={changelogPanel === 2}
          onChange={handleChangelog(2)}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMore />}>
            <Typography
              variant="body1"
              classes={{ body1: classes.panelHeader }}
            >
              v1.1.1 <code style={panelHeaderDate}>2020.05.29</code>
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <ul style={ulStyle}>
              <li>Added support for Seasonal Quest Packs</li>
              <li>Fixed Season 5 Pack distribution</li>
              <li>Bug fixes and various enhancements</li>
            </ul>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel
          expanded={changelogPanel === 1}
          onChange={handleChangelog(1)}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMore />}>
            <Typography
              variant="body1"
              classes={{ body1: classes.panelHeader }}
            >
              v1.1.0 <code style={panelHeaderDate}>2020.05.11</code>
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <ul style={ulStyle}>
              <li>Add support for Season 5: Fortune's Favor</li>
              <li>Add support for bonus Twitch Prime packs</li>
              <li>Upgrade progress visualizations</li>
              <li>
                Enhance underlying premium battle pass pack distribution logic
              </li>
              <li>Enhance the activity input area</li>
              <li>Enhance the progress report area</li>
              <li>
                Enhance mobile support and made better responsive decisions
              </li>
              <li>Identify returning users based on account packs</li>
            </ul>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel
          expanded={changelogPanel === 0}
          onChange={handleChangelog(0)}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMore />}>
            <Typography
              variant="body1"
              classes={{ body1: classes.panelHeader }}
            >
              v1.0.0 <code style={panelHeaderDate}>2020.02.12</code>
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <ul style={ulStyle}>
              <li>Initial release</li>
            </ul>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </Box>
    </div>
  );
};
